// src/pages/const/OrderCompleteView.jsx
import React, { useState } from "react";
import { useParams } from "react-router-dom";

import FormViewManager from "../../components/common/form/FormViewManager";
import TableCell from "../../components/common/ui/TableCell";
import TinyMCEpreview from "../../components/const/TinyMCEpreview";
import PhotoBoardReadonly from "../../components/const/Photo/PhotoBoardReadonly";
import SignTableDocSingle from "../../components/approval/SignTable_doc_single";

/* BodyComponent (children)
   FormViewManager에서 meta, data 자동 전달
  */
function OrderCompleteBody({ meta, data, project }) {
  const report = data || {};

  return (
    <>
      {/* 기본정보 Table*/}
      <div className="overflow-hidden mb-8 border-t border-black">
        <table className="w-full text-sm table-fixed">
          <colgroup>
            <col style={{ width: "110px" }} />
            <col />
            <col style={{ width: "110px" }} />
            <col />
          </colgroup>

          <tbody>
            <tr></tr>
            <tr>
              <TableCell
                label="작업지시서"
                colSpan={3}
                value={
                  report.meta?.workorder ? (
                    <a
                      href={`/project/${project}/const/order/${report.meta.workorder}/view`}
                      className="text-blue-600 hover:underline"
                    >
                      {report.workorder_title || "작업지시서 보기"}
                    </a>
                  ) : (
                    "-"
                  )
                }
              />
            </tr>
          </tbody>
        </table>
      </div>

      {/* 상세내용*/}
      <div className="mb-6">
        <div className="tbl-label-bg">
          상세 내용
        </div>

        <div className="px-3 py-4 border-r border-l border-b border-black whitespace-pre-line min-h-[140px]">
          <TinyMCEpreview html={meta.detail || "<p>내용이 없습니다.</p>"} />
        </div>
      </div>

      {/* 사진대지*/}
      <div className="mb-6 ">
        <div className="tbl-label-bg">
          사진대지
        </div>

        <div className="px-3 py-4 border-r border-l border-b border-black">
          {meta.photoboard ? (
            <PhotoBoardReadonly photoboardId={meta.photoboard} />
          ) : (
            <p className="text-gray-500">연결된 사진대지가 없습니다.</p>
          )}
        </div>
      </div>

      <div className="mb-6">
        <SignTableDocSingle
          dns={data?.dns || ""}
          onlyLastApprover={true}
          showEmptyBox={true}
        />
      </div>

    </>
  );
}

export default function OrderCompleteView() {
  const { completionreportId, id: project } = useParams();

  return (
    <FormViewManager
      params={{
        project,
        dns: completionreportId,
        module: "const",
        doc_type: "ordercomplete",
      }}
      doc_name="완료보고서"
      app_action
    >
      <OrderCompleteBody />
    </FormViewManager>
  );
}
